
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class PiStatisticsBoxComponents extends Vue {
  @Prop({ default: "" }) private size!: string;
}
